/**
 * pauseAdContainer.tsx
 */
import Colors from '@shared/assets/style/default/color';
import styled from 'styled-components';
import { TRANSITION } from '@shared/types/constants/animations';

const PauseAdContainer = styled.div<{
  delay?: number;
  duration?: number;
  opacity?: number;
}>`
  background: ${Colors.background};
  display: flex;
  height: 100vh;
  justify-content: center;
  opacity: ${(props) => props.opacity};
  position: absolute;
  transition: ${(props) => TRANSITION.PAUSE_AD(props.duration, props.delay)};
  width: 100vw;
  z-index: 150; // Place pause ad on top of the player and pilot
`;

export default PauseAdContainer;
